var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "testTemplate" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalTest",
            size: "lg",
            centered: "",
            "cancel-disabled": "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            "hide-footer": "",
            title: _vm.$t("dialog-title-videoTest")
          },
          model: {
            value: _vm.localValue,
            callback: function($$v) {
              _vm.localValue = $$v
            },
            expression: "localValue"
          }
        },
        [
          _vm.modalStep === 0
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "mx-auto", staticStyle: { width: "96px" } },
                  [
                    _c("img", {
                      attrs: {
                        width: "96px",
                        height: "96px",
                        alt: "Test",
                        src: "/static-appopensalud/img/icons/test-icon.svg"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.inputSmallToken
                  ? _c(
                      "div",
                      { staticClass: "col text-center pt-1" },
                      [
                        _c("p", { staticStyle: { "text-align": "center" } }, [
                          _vm._v(_vm._s(_vm.$t("needValidTokenVideoTest")))
                        ]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          attrs: {
                            readonly: _vm.waitingSessionCheck,
                            id: "token-input",
                            placeholder: _vm.$t("introduce-token")
                          },
                          model: {
                            value: _vm.smallToken,
                            callback: function($$v) {
                              _vm.smallToken = $$v
                            },
                            expression: "smallToken"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col text-center" },
                  [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("dialog-title-presentation")))
                    ]),
                    _vm._v(" "),
                    !_vm.waitingSessionCheck
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              center: "",
                              "align-h": "center",
                              variant: "outline-primary"
                            },
                            on: { click: _vm.stepOne }
                          },
                          [
                            _c("b-icon", {
                              attrs: { icon: "play", "aria-hidden": "true" }
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("dialog-title-pressToInitVideoTest")
                                )
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.waitingSessionCheck
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              center: "",
                              disabled: "",
                              "align-h": "center",
                              variant: "outline-primary"
                            },
                            on: { click: _vm.stepOne }
                          },
                          [
                            _c("b-spinner", {
                              attrs: { small: "", label: "Spinning" }
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("dialog-title-waitingSession"))
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.modalStep === -1
              ? _c("div", { staticStyle: { "min-height": "360px" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "mx-auto",
                      staticStyle: { width: "96px", margin: "20px 0 40px 0" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "96px",
                          height: "96px",
                          alt: "danger",
                          src: "/static-appopensalud/img/icons/danger-icon.svg"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.otLoggingError
                    ? _c("div", [
                        _c("p", { staticClass: "text-danger text-center" }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.$t("video-test.adblock-error")))
                          ])
                        ])
                      ])
                    : _c("div", [
                        _c("p", { staticClass: "text-danger text-center" }, [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "dialog-title-minimumRequisitesVideoTest"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-danger errorPanel" }, [
                          _c("small", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("test-requisites")) +
                                "\n            "
                            )
                          ])
                        ])
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col text-center mt-2" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            center: "",
                            "align-h": "center",
                            variant: "outline-danger"
                          },
                          on: { click: _vm.retryTest }
                        },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "arrow-counterclockwise",
                              "aria-hidden": "true"
                            }
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("retry-init")) + "\n          "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.modalStep === 1
              ? _c(
                  "div",
                  { staticStyle: { "min-height": "360px" } },
                  [
                    _c(
                      "b-tabs",
                      {
                        attrs: { "content-class": "mt-3 p-0" },
                        model: {
                          value: _vm.tabActive,
                          callback: function($$v) {
                            _vm.tabActive = $$v
                          },
                          expression: "tabActive"
                        }
                      },
                      [
                        _c(
                          "b-tab",
                          {
                            staticClass: "p-0",
                            attrs: { disabled: _vm.tabActive !== 0 },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "dialog_title_tabOneVideoTest"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3753438429
                            )
                          },
                          [
                            _vm._v(" "),
                            (_vm.videoGranted == null &&
                              _vm.audioGranted == null) ||
                            (_vm.videoGranted && _vm.audioGranted)
                              ? _c("p", { staticClass: "p-2 text-justify" }, [
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dialog-text1-tab1-VdeoTest")
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.videoGranted != null &&
                            _vm.audioGranted != null &&
                            (!_vm.videoGranted && !_vm.audioGranted)
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "p-2 text-danger text-center"
                                  },
                                  [
                                    _c("small", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "dialog-text2-tab1-VideoTest"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-container",
                              {
                                staticClass: "text-center",
                                attrs: { fluid: "md" }
                              },
                              [
                                _c(
                                  "b-row",
                                  { attrs: { justified: "" } },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _vm.videoGranted
                                          ? _c("b-img", {
                                              staticClass: "p-4",
                                              class: {
                                                bgPermission: _vm.videoGranted,
                                                bgNoPermission: !_vm.videoGranted
                                              },
                                              attrs: {
                                                "align-h": "center",
                                                src:
                                                  "/static-appopensalud/img/icons/webcam-white.svg",
                                                width: "96px",
                                                rounded: "circle"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.videoGranted
                                          ? _c("b-img", {
                                              staticClass: "p-4",
                                              class: {
                                                bgPermission: _vm.videoGranted,
                                                bgNoPermission: !_vm.videoGranted
                                              },
                                              attrs: {
                                                "align-h": "center",
                                                src:
                                                  "/static-appopensalud/img/icons/webcam-slash-white.svg",
                                                width: "96px",
                                                rounded: "circle"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("p", [
                                          _c("small", [
                                            _vm._v(_vm._s(_vm.$t("camera")))
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _vm.audioGranted
                                          ? _c("b-img", {
                                              staticClass: "p-4",
                                              class: {
                                                bgPermission: _vm.audioGranted,
                                                bgNoPermission: !_vm.audioGranted
                                              },
                                              attrs: {
                                                src:
                                                  "/static-appopensalud/img/icons/microphone-white.svg",
                                                width: "96px",
                                                rounded: "circle"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.audioGranted
                                          ? _c("b-img", {
                                              staticClass: "p-4",
                                              class: {
                                                bgPermission: _vm.audioGranted,
                                                bgNoPermission: !_vm.audioGranted
                                              },
                                              attrs: {
                                                src:
                                                  "/static-appopensalud/img/icons/microphone-slash-white.svg",
                                                width: "96px",
                                                rounded: "circle"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("p", [
                                          _c("small", [
                                            _vm._v(_vm._s(_vm.$t("microphone")))
                                          ])
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col text-center" },
                              [
                                _c("div", { staticClass: "footerLine mb-3" }),
                                _vm._v(" "),
                                !_vm.reAskpermission &&
                                !_vm.stepOnePassed &&
                                _vm.tabActive === 0 &&
                                !_vm.waitingDevices
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          center: "",
                                          "align-h": "center",
                                          variant: "outline-primary"
                                        },
                                        on: { click: _vm.checkPermissions }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "chat-square-dots",
                                            "aria-hidden": "true"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("request-permissions")
                                            )
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.reAskpermission &&
                                !_vm.stepOnePassed &&
                                _vm.tabActive === 0 &&
                                !_vm.waitingDevices
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          center: "",
                                          "align-h": "center",
                                          variant: "outline-danger"
                                        },
                                        on: { click: _vm.retryTest }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "arrow-counterclockwise",
                                            "aria-hidden": "true"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("retry-init")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.stepOnePassed &&
                                _vm.tabActive === 0 &&
                                !_vm.waitingDevices
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          center: "",
                                          "align-h": "center",
                                          variant: "outline-primary"
                                        },
                                        on: { click: _vm.stepTwo }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "arrow-right",
                                            "aria-hidden": "true"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("next-label")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.stepOnePassed &&
                                _vm.tabActive === 0 &&
                                _vm.waitingDevices
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          center: "",
                                          disabled: "",
                                          "align-h": "center",
                                          variant: "outline-primary"
                                        },
                                        on: { click: _vm.stepTwo }
                                      },
                                      [
                                        _c("b-spinner", {
                                          attrs: {
                                            small: "",
                                            label: "Spinning"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("checkingDevices"))
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          {
                            staticClass: "p-0",
                            attrs: { disabled: _vm.tabActive !== 1 },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("devices")) +
                                          "\n            "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2027547690
                            )
                          },
                          [
                            _vm._v(" "),
                            _c("p", [
                              _c("small", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("test-center-image-and-audio")
                                    )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-container",
                              { staticClass: "bv-example-row" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { md: "3", sm: "12" } },
                                      [
                                        _c("video", {
                                          staticClass: "device-center",
                                          attrs: {
                                            id: "localVideo",
                                            autoplay: "",
                                            playsinline: ""
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "pl-4",
                                        attrs: { md: "9", sm: "12" }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: { "margin-top": "0" }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("video-device")) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("b-form-input", {
                                          attrs: {
                                            readonly: "",
                                            placeholder: _vm.webcamString
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("hr"),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { attrs: { "align-h": "center" } },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { md: "3", sm: "12" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "device-center text-center"
                                          },
                                          [
                                            _c("b-img", {
                                              attrs: {
                                                src:
                                                  "/static-appopensalud/img/icons/microphone-blue.svg",
                                                width: "20px"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-top": "15px"
                                                }
                                              },
                                              [
                                                _c("meter", {
                                                  attrs: {
                                                    high: "0.25",
                                                    max: "1",
                                                    value: "0"
                                                  }
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "pl-4",
                                        attrs: { md: "9", sm: "12" }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: { "margin-top": "0" }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("audio-device")) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("b-form-input", {
                                          attrs: {
                                            readonly: "",
                                            placeholder: _vm.microString
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col text-center" },
                              [
                                _c("div", { staticClass: "footerLine mb-3" }),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      center: "",
                                      "align-h": "center",
                                      variant: "outline-primary"
                                    },
                                    on: { click: _vm.stepThree }
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "arrow-right",
                                        "aria-hidden": "true"
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("next-label")) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          {
                            staticClass: "p-0",
                            attrs: { disabled: _vm.tabActive !== 2 },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("network")) +
                                          "\n            "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2180834591
                            )
                          },
                          [
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(_vm._s(_vm.$t("dialog-title-speedTest")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-container",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass: "px-0",
                                    attrs: { justified: "" }
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "px0 speed-box-border",
                                        attrs: { md: "6", sm: "12" }
                                      },
                                      [
                                        _c("highcharts", {
                                          ref: "highchartVideo",
                                          attrs: { options: _vm.videoOptions }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "px0",
                                        attrs: { md: "6", sm: "12" }
                                      },
                                      [
                                        _c("highcharts", {
                                          ref: "highchartsAudio",
                                          attrs: { options: _vm.audioOptions }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            !_vm.waitingTestDone
                              ? _c("div", [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dialog-title-overalRatingVideoTest"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("RatingCustom", {
                                        attrs: {
                                          title: _vm.$t("video-quality"),
                                          rating:
                                            _vm.resultTestValues
                                              .videoQualityValue
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("RatingCustom", {
                                        attrs: {
                                          title: _vm.$t("audio-quality"),
                                          rating:
                                            _vm.resultTestValues
                                              .audioQualityValue
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("dialog-title-resultVideoTest")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.resultTest
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c("b-icon", {
                                            attrs: {
                                              "font-scale": "3",
                                              variant: "primary",
                                              icon: "check2-circle",
                                              "aria-hidden": "true"
                                            }
                                          }),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "h6",
                                            {
                                              staticClass:
                                                "text-center text-primary"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "title-result-test-ok"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.resultTest
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          _c("b-icon", {
                                            attrs: {
                                              "font-scale": "3",
                                              variant: "danger",
                                              icon: "x-circle",
                                              "aria-hidden": "true"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "text-center text-danger"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "tittle-resulta-test-ko"
                                                  )
                                                ) + " "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "subtitle-result-test-ko"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col text-center" },
                              [
                                _c("div", { staticClass: "footerLine mb-3" }),
                                _vm._v(" "),
                                !_vm.waitingTestDone
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "m-1",
                                        attrs: {
                                          center: "",
                                          "align-h": "center",
                                          variant: "outline-danger"
                                        },
                                        on: { click: _vm.retryTest }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "arrow-counterclockwise",
                                            "aria-hidden": "true"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("retry-init")) +
                                            "\n                "
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.waitingTestDone
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "m-1",
                                        attrs: {
                                          center: "",
                                          "align-h": "center",
                                          variant: "outline-primary"
                                        },
                                        on: { click: _vm.stepRedirectSession }
                                      },
                                      [_vm._v(" " + _vm._s(_vm.successText))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.waitingTestDone
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "m-1",
                                        attrs: {
                                          center: "",
                                          disabled: "",
                                          "align-h": "center",
                                          variant: "outline-primary"
                                        },
                                        on: { click: _vm.stepOne }
                                      },
                                      [
                                        _c("b-spinner", {
                                          attrs: {
                                            small: "",
                                            label: "Spinning"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "dialog-button-waitingTest"
                                              )
                                            )
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fb23e8f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb23e8f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/Test.vue
// module id = 3045
// module chunks = 2 26